import React from "react";
import { Box, useTheme } from "@mui/material";

interface BrandLogoProps {
  compact?: boolean;
  showTagline?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  compact = false,
  showTagline = false,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const accentGreen = isDark ? "#00E676" : "#00C471";
  const accentBlue = isDark ? "#4D8FFF" : "#0047FF";
  const taglineColor = isDark ? "rgba(255,255,255,0.3)" : "#888888";
  const viewBoxWidth = showTagline ? 260 : compact ? 190 : 220;
  const viewBoxHeight = showTagline ? 56 : compact ? 38 : 54;
  const textX = compact ? 34 : 52;
  const textY = compact ? 21 : 27;
  const fontSize = compact ? 19 : 22;
  const letterSpacing = compact ? 1.5 : 1.6;

  return (
    <Box
      dir="ltr"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 0,
        userSelect: "none",
        direction: "ltr",
      }}
      aria-label="Medibroking"
    >
      <svg
        width="100%"
        height={compact ? 38 : showTagline ? 56 : 54}
        viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        // aria-hidden="true"
        preserveAspectRatio="xMinYMid meet"
        style={{ direction: "ltr" }}
      >
        {compact ? (
          <>
            <circle cx="14" cy="16" r="12" fill="none" stroke={accentGreen} strokeWidth="0.6" />
            <path
              d="M 4,23 A11,11 0 0,0 24,23"
              fill="none"
              stroke={accentBlue}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle cx="14" cy="5" r="3" fill={accentGreen} />
            <circle cx="14" cy="5" r="5" fill={accentGreen} opacity={isDark ? "0.18" : "0.15"} />
            <circle cx="5" cy="22" r="1.2" fill={accentGreen} />
            <circle cx="14" cy="26" r="1.4" fill={accentGreen} />
            <circle cx="23" cy="22" r="1.2" fill={accentGreen} />
          </>
        ) : (
          <>
            <circle cx="22" cy="24" r="19" fill="none" stroke={accentGreen} strokeWidth="0.7" />
            <path
              d="M 6,34 A18,18 0 0,0 38,34"
              fill="none"
              stroke={accentBlue}
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="22" cy="6" r="4" fill={accentGreen} />
            <circle cx="22" cy="6" r="6.5" fill={accentGreen} opacity={isDark ? "0.18" : "0.15"} />
            <circle cx="9" cy="32" r="1.6" fill={accentGreen} />
            <circle cx="22" cy="38" r="1.9" fill={accentGreen} />
            <circle cx="35" cy="32" r="1.6" fill={accentGreen} />
          </>
        )}

        <text
          x={textX}
          y={textY}
          fontFamily="'Syne', 'Helvetica Neue', Arial, sans-serif"
          fontSize={fontSize}
          letterSpacing={letterSpacing}
        >
          <tspan fontWeight="700" fill={accentBlue}>
            Medi
          </tspan>
          <tspan fontWeight="400" fill={accentGreen}>
            broking
          </tspan>
        </text>

        {showTagline && !compact ? (
          <text
            x="185"
            y="39"
            fontFamily="'Syne', 'Helvetica Neue', Arial, sans-serif"
            fontSize="7"
            fill={taglineColor}
            textLength="127"
            lengthAdjust="spacing"
          >
            a place for them all
          </text>
        ) : null}
      </svg>
    </Box>
  );
};

export default BrandLogo;